<svg
	width="100%"
	height="100%"
	stroke-width="1.5"
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	color="currentColor"
	><path
		d="M5 13L9 17L19 7"
		stroke="currentColor"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	></path></svg
>
